import React, { createContext } from "react";

const individualsContext = createContext()

export default individualsContext